module.exports = __webpack_public_path__ + "img/icon-music.de0026cd.png";